import { defineComponent } from 'vue'
import Card from 'ant-design-vue/lib/card'
import Input from 'ant-design-vue/lib/input'

export default defineComponent(() => {
    return () => <div class='body layout-center'>
        <Card>
            <div style={{width:'200px'}}>
                <Input />
            </div>
        </Card>
    </div>
})